export default __webpack_public_path__ + "static/media/liver.bb5bae3b.svg";